import React, { Component } from 'react';
import PropTypes from 'prop-types';
import HistoryLogs from '../history-logs';

class HistoryLogsWrapper extends Component {
  render() {
    const { opportunity, type, children } = this.props;
    let count = 0;
    if (opportunity && opportunity.logs && opportunity.logs[type]) {
      count = opportunity.logs[type];
    }
    if (count > 0) {
      return (
        <HistoryLogs opportunity={opportunity} type={type}>
          {children}
        </HistoryLogs>
      );
    }
    return children;
  }
}

HistoryLogsWrapper.propTypes = {
  children: PropTypes.node,
  type: PropTypes.string.isRequired,
  opportunity: PropTypes.shape({
    opportunity_id: PropTypes.string.isRequired,
    logs: PropTypes.shape({}),
  }).isRequired,
};

HistoryLogsWrapper.defaultProps = {
  children: null,
};

export default HistoryLogsWrapper;
